// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1VLGD","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__m2YEX"};